import React from 'react';
import { motion } from 'framer-motion';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
interface InlineCTAProps {
  label: string;
  position: string;
}
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function InlineCTA({
  label,
  position
}: InlineCTAProps) {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="w-full max-w-3xl mx-auto my-12 px-4 flex justify-center" data-id="element-111">
      <a href={href} onClick={() => trackCTAClick(label, position)} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto text-center bg-forest hover:bg-forest-light text-cream font-serif font-semibold text-lg py-4 px-8 rounded-full shadow-md hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300" data-id="element-112">
        {label}
      </a>
    </motion.div>;
}